export default {
	messages: {
		required: (field) => `The ${field} field is required`,
		min: (field) => `The ${field} field is too short`,
		max: (field) => `The ${field} field is too long`,
		email: (field) => `The ${field} field must be a valid email`,
		numeric: (field) => `The ${field} field must be numeric`,
		integer: (field) => `The ${field} field must be an integer number`,
		regex: (field) => `The ${field} field format is not valid`,
		between: (field) => `The ${field} field is out of allowed range`,
		mimes: (field) => `The ${field} file format is not valid`,
		size: (field) => `The ${field} file is too large`
	},
	custom : {
		email : {
			required : 'The email is mandatory',
			email : 'You must provide a valid email address'
		},
		telefono : {
			required : 'The telephone field is required',
			length : 'The telephone field is wrong'
		},
		nombre : {
			required : 'The name field is required'
		},
		mensaje : {
			required : 'The message field is required'
		},
		apellidos : {
			required : 'The surname field is required'
		},
		politica : {
			required : 'You must accept the privacy policy'
		},
		comunicaciones : {
			required : 'You must accept to send communications'
		},
		empresa : {
			required : 'Company field is required'
		},
		direccion : {
			required : 'The address field is required'
		},
		pais : {
			required : 'Country field is required'
		},
		carta_presentacion : {
			required : 'The letter of introduction field is required'
		},
		doc_adjunto : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		},
		email_firmante: {
			required: 'The signatory email field is required',
			email: 'The signatory email field must be a valid email'
		},
		curso: {
			required: 'The academic year field is required'
		},
		titulacion: {
			required: 'The degree field is required'
		},
		puestoTrabajo: {
			required: 'The job position field is required'
		},
		horasDia: {
			required: 'The hours per day field is required',
			numeric: 'The hours per day field must be numeric'
		},
		departamentoalumno: {
			required: 'The department field is required'
		},
		ayudaEstudio: {
			required: 'The remuneration field is required',
			regex: 'The remuneration field must be a valid number'
		},
		meses: {
			required: 'The duration in months field is required'
		},
		tiempoDedicacionJornada: {
			required: 'The dedication percentage field is required',
			integer: 'The dedication percentage field must be an integer number'
		},
		area_funcional: {
			required: 'The functional area field is required'
		},
		pais: {
			required: 'The country field is required'
		},
		provincia: {
			required: 'The province field is required'
		},
		localidad: {
			required: 'The city field is required'
		},
		direccion: {
			required: 'The address field is required'
		},
		numeroDiasSemana: {
			required: 'The number of days per week field is required',
			between: 'The number of days per week must be between 1 and 7',
			numeric: 'The number of days per week must be numeric'
		},
		diasDeLaSemana: {
			required: 'The days of the week field is required'
		},
		nombreTutorUni: {
			required: 'The university tutor name field is required'
		},
		nombreTutorEmpresa: {
			required: 'The company tutor name field is required'
		},
		ApellidosTutorEmpresa: {
			required: 'The company tutor surname field is required'
		},
		emailTutorEmpresa: {
			required: 'The company tutor email field is required',
			email: 'You must provide a valid company tutor email address'
		},
		telefonoTutorEmpresa: {
			required: 'The company tutor phone field is required',
			min: 'The company tutor phone is too short',
			max: 'The company tutor phone is too long'
		},
		cargoTutorEmpresa: {
			required: 'The company tutor role field is required'
		},
		dniTutorEmpresa: {
			required: 'The company tutor ID field is required'
		},
		departamentoTutorEmpresa: {
			required: 'The company tutor department field is required'
		},
		titulacionTutorEmpresa: {
			required: 'The company tutor degree field is required'
		},
		fechaInicio: {
			required: 'The start date field is required'
		},
		fechaFin: {
			required: 'The end date field is required'
		},
		tareasAdesarrollar: {
			required: 'The tasks to be carried out field is required',
			min: 'The tasks to be carried out field is too short'
		},
		tipo_oferta: {
			required: 'The offer type field is required'
		},
		condicionespracticas: {
			required: 'You must accept the internship conditions'
		},
		idProgramaPracticas: {
			required: 'The internship program field is required'
		},
		titulo: {
			required: 'The offer name field is required'
		},
		plazas: {
			required: 'The number of places field is required',
			numeric: 'The number of places field must be numeric',
			min: 'The number of places must be at least 1'
		},
		experienciadeseable: {
			required: 'The desirable experience field is required'
		},
		isla: {
			required: 'The island field is required'
		},
		idpoblacion: {
			required: 'The city field is required'
		},
		horasAldia: {
			required: 'The hours per day field is required',
			regex: 'The hours per day field must be a valid number'
		},
		salario: {
			required: 'The remuneration range field is required'
		},
		otrasRemuneraciones: {
			required: 'The additional benefits field is required'
		},
		tipoopcionpublicacion: {
			required: 'The publication option field is required'
		},
		urlInscripcionExterna: {
			regex: 'The external application URL is not valid'
		},
		datosCandidatoPreferido: {
			required: 'The preferred candidate details field is required'
		},
		conocimientosEspecificos: {
			required: 'The specific knowledge field is required'
		},
		formacionAdquirida: {
			required: 'The expected learning outcomes field is required'
		},
		seguimientoPrevisto: {
			required: 'The planned follow-up field is required'
		},
		tareauno: {
			required: 'Task 1 is required'
		},
		tareados: {
			required: 'Task 2 is required'
		},
		tareatres: {
			required: 'Task 3 is required'
		},
		otratareas: {
			min: 'The other tasks field is too short'
		},
		observacionesPublicas: {
			max: 'The public comments field is too long'
		},
		nombrefirmante: {
			required: 'The signatory name field is required'
		},
		apellidosfirmante: {
			required: 'The signatory surname field is required'
		},
		cargofirmante: {
			required: 'The signatory role field is required'
		},
		emailfirmante: {
			required: 'The signatory email field is required',
			email: 'The signatory email field must be a valid email'
		},
		telefonofirmante: {
			required: 'The signatory phone field is required',
			min: 'The signatory phone is too short',
			max: 'The signatory phone is too long'
		},
		tutores: {
			required: 'The tutor field is required'
		},
		nombretutor: {
			required: 'The tutor name field is required'
		},
		apellidostutor: {
			required: 'The tutor surname field is required'
		},
		cargotutor: {
			required: 'The tutor role field is required'
		},
		emailtutor: {
			required: 'The tutor email field is required',
			email: 'The tutor email field must be a valid email'
		},
		telefonotutor: {
			required: 'The tutor phone field is required',
			min: 'The tutor phone is too short',
			max: 'The tutor phone is too long'
		},
		departamentotutor: {
			required: 'The tutor department field is required'
		},
		dnitotutor: {
			required: 'The tutor ID field is required'
		},
		titulaciontotutor: {
			required: 'The tutor degree field is required'
		},
		cursoMinimoRequerido: {
			min: 'The minimum course must be at least 1',
			numeric: 'The minimum course must be numeric'
		},
		listado_titulaciones_deseables: {
			required: 'Please select at least one desirable degree'
		},
		listado_titulaciones_propuestas: {
			required: 'Please select at least one proposed degree'
		},
		anyopromocionmaximo: {
			required: 'The maximum graduation year field is required'
		},
		file: {
			size: 'The maximum file size is 20MB',
			mimes: 'Invalid file format'
		},
		informacionTratamientoDeDatos: {
			required: 'This field is required'
		},
		cif: {
			required: 'The VAT/Tax ID field is required',
			length: 'The VAT/Tax ID format is not valid'
		},
		nombre_usuario: {
			required: 'The username field is required'
		},
		puesto: {
			required: 'The role field is required'
		},
		telefono_empresa: {
			required: 'The company phone field is required',
			min: 'The company phone is too short',
			max: 'The company phone is too long'
		},
		telefono2: {
			required: 'The phone field is required',
			min: 'The phone is too short',
			max: 'The phone is too long'
		},
		sede: {
			required: 'The site field is required'
		},
		experiencia: {
			required: 'The experience field is required'
		},
		password: {
			required: 'The password field is required',
			min: 'The password must have at least 8 characters',
			confirmed: 'Passwords do not match',
			digits: 'The password must contain at least one number'
		},
		password2: {
			required: 'The password field is required',
			min: 'The password must have at least 8 characters',
			confirmed: 'Passwords do not match',
			digits: 'The password must contain at least one number'
		},
		cp: {
			required: 'The postal code field is required'
		},
		paiscontacto: {
			required: 'The country field is required'
		},
		filePoliza: {
			size: 'The maximum file size is 2MB',
			mimes: 'The file format must be PDF'
		},
		poblacion: {
			required: 'The city field is required'
		},
		provinciacontacto: {
			required: 'The province field is required'
		},
		remuneraciones: {
			required: 'The additional benefits field is required'
		},
		contrato: {
			required: 'The contract type field is required'
		},
		descripcion: {
			required: 'The description field is required'
		},
		departamento: {
			required: 'The department field is required'
		},
		nombreFiscal: {
			required: 'The legal name field is required'
		},
		nombreComercial: {
			required: 'The trade name field is required'
		},
		codigo_postal: {
			required: 'The postal code field is required'
		},
		nombre_comercial: {
			required: 'The trade name field is required'
		},
		nombre_fiscal: {
			required: 'The legal name field is required'
		},
		listado_titulaciones: {
			required: 'Please select at least one required degree'
		},
		privada: {
			required: 'The company type field is required'
		},
		tipoEmpresa: {
			required: 'The company legal type field is required',
			min_value: 'The company legal type field is required'
		},
		sector: {
			required: 'The sector field is required'
		},
		startup: {
			required: 'The startup field is required'
		},
		url: {
			url: 'The URL format is not valid'
		},
		checkdni: {
			checkdni: 'The ID format is not valid'
		},
		iban: {
			checkiban: 'The IBAN format is not valid'
		},
		linkedin: {
			regex: 'The LinkedIn URL contains errors'
		},
		nota: {
			between: 'The value must be between 1 and 4'
		}
	},
	attributes: {
		tipo_oferta: 'offer type',
		condicionespracticas: 'internship conditions',
		idProgramaPracticas: 'internship program',
		titulo: 'offer name',
		plazas: 'number of places',
		area_funcional: 'functional area',
		experiencia: 'experience',
		experienciadeseable: 'desirable experience',
		contrato: 'contract type',
		pais: 'country',
		provincia: 'province',
		isla: 'island',
		poblacion: 'location',
		idpoblacion: 'location',
		direccion: 'address',
		horario: 'schedule',
		horasAldia: 'hours per day',
		horasDia: 'hours per day',
		tiempoDedicacionJornada: 'dedication percentage',
		meses: 'duration in months',
		fechaInicio: 'start date',
		fechaFin: 'end date',
		salario: 'remuneration range',
		ayudaEstudio: 'remuneration',
		otrasRemuneraciones: 'additional benefits',
		tipoopcionpublicacion: 'publication option',
		urlInscripcionExterna: 'external application URL',
		datosCandidatoPreferido: 'preferred candidate details',
		conocimientosEspecificos: 'specific knowledge',
		formacionAdquirida: 'expected learning outcomes',
		seguimientoPrevisto: 'planned follow-up',
		descripcion: 'description',
		tareauno: 'task 1',
		tareados: 'task 2',
		tareatres: 'task 3',
		otratareas: 'other tasks',
		modalidad: 'modality',
		observacionesPublicas: 'public comments',
		nombrefirmante: 'signatory name',
		apellidosfirmante: 'signatory surname',
		cargofirmante: 'signatory role',
		emailfirmante: 'signatory email',
		telefonofirmante: 'signatory phone',
		tutores: 'tutor',
		nombretutor: 'tutor name',
		apellidostutor: 'tutor surname',
		cargotutor: 'tutor role',
		emailtutor: 'tutor email',
		telefonotutor: 'tutor phone',
		departamentotutor: 'tutor department',
		dnitotutor: 'tutor ID',
		titulaciontotutor: 'tutor degree',
		cursoMinimoRequerido: 'minimum year',
		listado_titulaciones: 'required degrees',
		listado_titulaciones_deseables: 'desirable degrees',
		listado_titulaciones_propuestas: 'proposed degrees',
		anyopromocionmaximo: 'maximum graduation year',
		file: 'file',
		email_firmante: 'signatory email',
		puestoTrabajo: 'job position',
		departamentoalumno: 'department',
		numeroDiasSemana: 'number of days per week',
		diasDeLaSemana: 'days of the week',
		nombreTutorUni: 'university tutor name',
		nombreTutorEmpresa: 'company tutor name',
		ApellidosTutorEmpresa: 'company tutor surname',
		emailTutorEmpresa: 'company tutor email',
		telefonoTutorEmpresa: 'company tutor phone',
		cargoTutorEmpresa: 'company tutor role',
		dniTutorEmpresa: 'company tutor ID',
		departamentoTutorEmpresa: 'company tutor department',
		titulacionTutorEmpresa: 'company tutor degree',
		tareasAdesarrollar: 'tasks to be carried out'
	}
}


// WEBPACK FOOTER //
// ./src/validator/en.js